module.exports = __webpack_public_path__ + "img/Confectioning_1200x800.9af33f29.png";